import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import React, { useCallback, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { formatReqUser, formatReqUserRole, isNominationWithTranscriptionNeeded } from '../../../util';
import { FormField } from '../../common/Forms';

const REQ_USER_NAME_FIELD = {
    id: 'name',
    name: 'Участник',
    inputType: 'text',
};
const REQ_USER_ROLE_FIELD = {
    id: 'role',
    name: 'Роль',
    inputType: 'text',
};
const REQ_USER_DESCRIPTION_FIELD = {
    id: 'description',
    name: 'Персонаж/пояснение',
    inputType: 'text',
};
const REQ_USER_TRANSCRIPTION_FIELD = {
    id: 'transcription',
    name: 'Транскрипция',
    inputType: 'text',
};

export function RequestUsersRow(props) {
    const { request, reqUser, index, readOnly, onUpdate, onDelete } = props;

    const handleUpdateUserClick = useCallback(() => {
        if (onUpdate) onUpdate(reqUser);
    }, [onUpdate, reqUser]);
    const handleDelUserClick = useCallback(() => {
        if (onDelete) onDelete(reqUser);
    }, [onDelete, reqUser]);

    const showTranscription = useMemo(() => {
        const nomination = request.nomination;
        const needTranscription = isNominationWithTranscriptionNeeded(nomination);
        const participantsCount = request.users.filter((data) => data.role === 'participant').length;
        return reqUser.description && reqUser.role === 'participant' && needTranscription && participantsCount <= 3;
    }, [reqUser, request]);

    const errors = useMemo(() => {
        const result = {};
        if (!reqUser.description) {
            result.description = 'Не может быть пустым';
        }
        if (!reqUser.transcription && showTranscription && /[A-Za-z]/.test(reqUser.description)) {
            result.transcription = 'Возможно нужна транскрипция';
        }
        return result;
    }, [reqUser, showTranscription]);
    return (
        <Row className="mb-2 pt-2 border-top">
            <Col sm={1}>{`${index + 1}.`}</Col>
            <Col sm={3}>
                <FormField
                    field={REQ_USER_NAME_FIELD}
                    value={formatReqUser(reqUser.user)}
                    hideLabelOnBigScreen
                    readOnly
                />
            </Col>
            <Col sm={2}>
                <FormField
                    field={REQ_USER_ROLE_FIELD}
                    value={formatReqUserRole(reqUser.role)}
                    hideLabelOnBigScreen
                    readOnly
                />
            </Col>
            <Col sm={4} className={showTranscription ? 'd-sm-flex' : ''}>
                <FormField
                    field={REQ_USER_DESCRIPTION_FIELD}
                    value={reqUser.description}
                    errors={errors}
                    hideLabelOnBigScreen
                    readOnly
                />
                {showTranscription && (
                    <FormField
                        field={REQ_USER_TRANSCRIPTION_FIELD}
                        value={reqUser.transcription}
                        errors={errors}
                        hideLabelOnBigScreen
                        readOnly
                    />
                )}
            </Col>
            <Col sm={2}>
                {!readOnly && (
                    <>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-edit-${reqUser.id}`}>Изменить</Tooltip>}
                        >
                            <Button variant="link" size="sm" className="" onClick={handleUpdateUserClick}>
                                <FontAwesomeIcon icon={faPen} size="1x" />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-remove-${reqUser.id}`}>Удалить</Tooltip>}
                        >
                            <Button variant="link" size="sm" className="text-danger" onClick={handleDelUserClick}>
                                <FontAwesomeIcon icon={faTimesCircle} size="1x" />
                            </Button>
                        </OverlayTrigger>
                    </>
                )}
            </Col>
        </Row>
    );
}
